import { makeReadContract } from '@/utils/wagmi/makeOperations'
import { abi } from '@/abi/Staking2a'
import { useStaking2aAddress } from './useStaking2aContract'

export const useReadStaking2aContract = makeReadContract(abi, useStaking2aAddress)
